import React, {useEffect, useMemo, useState} from 'react';
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import {isRTL, t} from "../../../../../../services/i18n";
import {Divider, HStack, Pressable, ScrollView, VStack, Text as NBText} from "native-base";
import ProTipBox from "../../../../../common/ProTipBox";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import {
    APPOINTMENT, CUSTOM_FIELD_SELECT,
    EXISTING_MEMBERSHIP,
    NO_MEMBERSHIP,
    ONE_TIME_PURCHASE,
    USERS_SELECT
} from "../../../../../../services/ConstHelper";
import {Colors} from "../../../../../../styles/Colors";
import moment from "moment";
import {dbDateFormat, sendDataEvent} from "../../../../../../services/Helpers";
import EStyleSheet from "react-native-extended-stylesheet";
import {useDispatch, useSelector} from "react-redux";
import {addToSelectionsTree, cleanStepper, setError, updateTempSelection} from "../../../../../../redux/stepperSlice";
import {optionalSteps} from "../StepOptions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {closeModal, CREATE_EVENT_MODAL, CREATE_USER_MODAL, openModal, STEPPER_CONFIRM_MODAL, updateModalRes} from "../../../../../../redux/modalManagerSlice";
import {Radio} from "antd";
import CustomButtonV2 from "../../../../../common/CustomButtonV2";
import CustomCheckbox from "../../../../../common/CustomCheckbox";
import {isMobile, handlePricingWithCurrency} from "../../../../../../services/Helpers";
import InfoTooltip from "../../../../../common/InfoTooltip";
import FormInput from "../../../../../common/FormInput";
import NoteSection from "../ReusableComponents/NoteSection";
import LiveLinkSetting from "../ReusableComponents/LiveLinkSetting";
import Box from "../../../../../common/Layout/Box";
import usePermissions from "../../../../../../services/Permissions";

const UserAndMembershipSelection = (props) => {
    const { values, errors, setFieldValue, oneTimeMembership, showOneTimePurchase, navigate, handleSubmit, allowMultiOneTimeMembership, allowScheduleNote, touched } = props;
    const error = useSelector((state) => state.stepper.error);
    const selectedLocation = useSelector(state => state.userSettings.scheduleLocation)
    const selectionTree = useSelector(state => state.stepper.selectionsTree)
    const services = useSelector(state => state.schedule.eventTypes.data)
    const editType = useSelector((state) => state.stepper.editType);
    const currencySymbol = useMemo(() => selectedLocation ? selectedLocation.currency_symbol : '',[selectedLocation])
    const serviceName = useMemo(() => {
        if(values?.scheduleTarget) return values?.scheduleTarget?.box_categories?.name ?? null
        else if(values?.box_category_fk) {
            const service = services[APPOINTMENT].find(item => item.id === values?.box_category_fk)
            return service?.name ?? null
        }
        return null
    },[values?.box_category_fk, values?.scheduleTarget])
    const dispatch = useDispatch()
    const {has} = usePermissions()

    useEffect(() => {
        sendDataEvent('add appointment pop up- UserAndMembershipSelection');
    }, []);

    useEffect(() => {
        if (values.scheduleUser?.user_fk) {
            onUserSelected()
        }
    }, [values.scheduleUser?.user_fk])

    useEffect(() => {
        if (values?.scheduleUser?.payment_info ) {
            handleSubmit()
        }
    }, [values?.scheduleUser?.payment_info])

    // useEffect(() => {
    //     if(values?.scheduleUser?.paymentObject) {
    //         dispatch(updateTempSelection({[optionalSteps.USER_AND_MEMBERSHIP_SELECTION]: true}))
    //     }
    // }, [values?.scheduleUser?.paymentObject])

    useEffect(() => {
        // on error: reset payment_info and and update selection tree (needs to open the modal again on next step)
        if(values?.scheduleUser?.payment_info && error) {
            setFieldValue('scheduleUser.payment_info', null)
            addOneTimePurchaseMembership()
            dispatch(setError(null))
        }
    }, [error])

    const setValue = (name, value, shouldParseInt = false) => {
        setFieldValue(name, shouldParseInt ? (isNaN(parseInt(value)) ? '' : parseInt(value)) : value)
    }

    const onUserSelected = () => {
        const user = selectionTree['user']
        if(user) {
            if(user.membership_user.length > 0) {
                addUserMembership(user.membership_user[0].id, user.membership_user[0].active)
            }
            else if(user.membership_user.length === 0 && !showOneTimePurchase && !allowMultiOneTimeMembership) {
                addUserWithoutMembership();
            }
            else {
                //if only pay for slot option is available
                if((showOneTimePurchase || allowMultiOneTimeMembership) && oneTimeMembership && user.type !== 'lead') {
                    addOneTimePurchaseMembership()
                }
            }
        }
    }

    const getMembershipSubheader = (membership) => {
        let subheader = t('membership-no-expiration-date')
        let tooltip = null
        if(membership.end && membership.sessions_left) {
            subheader = t('membership-end-date-sessions-left', {date: moment(membership.end, dbDateFormat).format('MMM DD, YYYY'), sessions: membership.sessions_left})
        } else if(membership.end) {
            subheader = t('membership-end-date', {date: moment(membership.end, dbDateFormat).format('MMM DD, YYYY')})
        } else if (membership.sessions_left) {
            if(has('delayPunches')) {
                const isDelayedPunch = !!membership.membership_types?.punch_on_arrival
                subheader = t(`membership-sessions-left-${isDelayedPunch ? 'delayed' : 'normal'}`, {sessions: membership.sessions_left})
                tooltip = t(`membership-sessions-left-${isDelayedPunch ? 'delayed' : 'normal'}-tooltip`)
            } else {
                subheader = t('membership-sessions-left', {sessions: membership.sessions_left})
            }
        }
        const text = <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{subheader}</AppText>
        if(tooltip) {
            return (
                <HStack>
                    {text}
                    <InfoTooltip title={tooltip}/>
                </HStack>
            )
        }
        return text;
    }

    const addOneTimePurchaseMembership = (isDebt = false) => {
        setValue('scheduleUser.debtSinglePfs', isDebt)
        setValue('scheduleUser.membership_user_fk', null)
        setValue('scheduleUser.paymentObject', {cart: oneTimeMembership})
        setValue('scheduleUser.isNoMembership', false)
        dispatch(updateTempSelection({[optionalSteps.USER_AND_MEMBERSHIP_SELECTION]: true}))
    }

    const addUserMembership = (membershipUserId, membershipUserIsActive) => {
        setValue('scheduleUser.debtSinglePfs', false)
        setValue('scheduleUser.membership_user_fk', membershipUserId)
        setValue('scheduleUser.membershipUserIsActive', membershipUserIsActive)
        setValue('scheduleUser.paymentObject', null)
        setValue('scheduleUser.isNoMembership', false)
        dispatch(updateTempSelection(null))
    }

    const addUserWithoutMembership = () => {
        setValue('scheduleUser.debtSinglePfs', false)
        setValue('scheduleUser.membership_user_fk', null)
        setValue('scheduleUser.paymentObject', null)
        setValue('scheduleUser.isNoMembership', true)
        dispatch(updateTempSelection(null))
    }

    const updateOrAddCustomField = (field, value, index) => {
        setValue(`customFields[${index}]`, {...field, value: value ?? null});
    }

    const onOnlineLinkRadioSelection = (selection) => {
        if(selection === 'in-person') setFieldValue('live_link', null)
        else setFieldValue('live_link', '')
    }

    const getPayForSlotOption = (isDebt = false) => {
        const cart = values.scheduleUser.paymentObject?.cart
        const debtSinglePfs = values.scheduleUser?.debtSinglePfs
        const selected = oneTimeMembership.id === cart?.id && ((isDebt && !!debtSinglePfs) || (!isDebt && !debtSinglePfs))
        return (
            <CustomButtonV2 onClick={() => addOneTimePurchaseMembership(isDebt)}
                            iconProps={{iconColor: Colors.borderColor, iconHoverColor: Colors.hoverBlueLight}}
                            override={({ color }) => (
                                <HStack space={'1rem'} p={'1rem'} w={'100%'} borderWidth={1} borderRadius={4} borderColor={selected ? Colors.newDesign.mainBlue : color}>
                                    <Radio onClick={(e) => {
                                        e.stopPropagation()
                                        addOneTimePurchaseMembership(isDebt)
                                    }} value={isDebt ? `${oneTimeMembership.id}-debt` : oneTimeMembership.id} size="sm" selected={selected}/>
                                    <VStack space={'0.2rem'}>
                                        <HStack space={'0.5rem'} alignItems={'center'}>
                                            <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{oneTimeMembership.name} ({t(isDebt ? 'debt-pfs' : 'payNow-pfs')})</AppText>
                                            <Divider orientation="vertical" bg={Colors.newDesign.darkGrey} thickness="1" h={"15px"}/>
                                            <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey}>{currencySymbol} {oneTimeMembership.price}</AppText>
                                        </HStack>
                                        <AppText fontSize={'12px'} color={Colors.newDesign.darkGrey}>{t(`pfs-appointment-${isDebt ? 'debt-' : ''}warning${isMobile ? '-mobile' : ''}`)}</AppText>
                                    </VStack>
                                </HStack>)}
            />
        )
    }

    const getSelectedRadio = () => {
        if(values.scheduleUser.membership_user_fk) return values.scheduleUser.membership_user_fk
        else if(values.scheduleUser?.debtSinglePfs) return `${oneTimeMembership.id}-debt`
        else if(values.scheduleUser.paymentObject?.cart?.id) return values.scheduleUser.paymentObject.cart.id
        return undefined
    }

    return (
        <VStack space={'1rem'}>
            {selectionTree['user'] && !editType && //added editType check just in case, but there is no selectionTree['user'] on edit
            <VStack space={'1rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.heading2Mobile} boldFont>{t('appointment-payment-section-header')}</AppText>
                <Divider style={{ margin: 0 }}/>
                <VStack space={'1.5rem'} flex={1} overflow={'hidden'}>
                    <VStack space={'0.2rem'} w={'100%'} overflowY={'auto'}>
                        <Radio.Group name={'users-membership-group'} value={getSelectedRadio()}>
                            <VStack space={'0.5rem'}>
                                {selectionTree['user'].membership_user.map(membership => (
                                    <CustomButtonV2 onClick={() => addUserMembership(membership.id, membership.active)} key={`membership-user-radio-${membership.id}`}
                                                    iconProps={{iconColor: Colors.borderColor, iconHoverColor: Colors.hoverBlueLight}}
                                                    override={({ color }) => (
                                                        <HStack space={'1rem'} p={'1rem'} alignItems={'start'} borderWidth={1} borderRadius={4} borderColor={membership.id === values.scheduleUser.membership_user_fk ? Colors.newDesign.mainBlue : color} w={'100%'}>
                                                            <Radio onClick={(e) => {
                                                                e.stopPropagation()
                                                                addUserMembership(membership.id, membership.active)
                                                            }} value={membership.id} size="sm" checked={membership.id === values.scheduleUser.membership_user_fk}/>
                                                            <VStack space={'0.5rem'}>
                                                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{membership.membership_types?.name} {!membership.active && `(${t('inactive')})`}</AppText>
                                                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{getMembershipSubheader(membership)}</AppText>
                                                            </VStack>
                                                        </HStack>)}
                                    />
                                ))}
                                {showOneTimePurchase && oneTimeMembership && selectionTree['user'].type !== 'lead' &&
                                    <>
                                    {getPayForSlotOption(true)}
                                    {getPayForSlotOption(false)}
                                    </>
                                }
                                {allowMultiOneTimeMembership &&
                                    <CustomButtonV2 onClick={() => addOneTimePurchaseMembership()}
                                                    iconProps={{iconColor: Colors.borderColor, iconHoverColor: Colors.hoverBlueLight}}
                                                    override={({ color }) => (
                                                        <HStack space={'1rem'} p={'1rem'} w={'100%'} borderWidth={1} borderRadius={4} borderColor={oneTimeMembership.id === values.scheduleUser.paymentObject?.cart.id ? Colors.newDesign.mainBlue : color} alignItems={'start'}>
                                                            <Radio onClick={(e) => {
                                                                e.stopPropagation()
                                                                addOneTimePurchaseMembership()
                                                            }} value={oneTimeMembership.id} size="sm" selected={oneTimeMembership.id === values.scheduleUser.paymentObject?.cart.id}/>
                                                            <VStack space={'0.2rem'}>
                                                                <HStack space={'0.5rem'} alignItems={'center'}>
                                                                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('pfs-recurring-appointment')}</AppText>
                                                                </HStack>
                                                                {isMobile ?
                                                                    <VStack>
                                                                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('pfs-recurring-appointment-price-mobile', {
                                                                            total: `${handlePricingWithCurrency((oneTimeMembership?.price * values.repeatConfig?.times)?.toLocaleString(), currencySymbol)}`,
                                                                            price: `${handlePricingWithCurrency((oneTimeMembership?.price)?.toLocaleString(), currencySymbol)}`,
                                                                            times: values.repeatConfig.times,
                                                                        })}</AppText>
                                                                    </VStack>
                                                                    :
                                                                    <HStack space={'0.5rem'} alignItems={'center'}>
                                                                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('pfs-recurring-appointment-price', {price: `${handlePricingWithCurrency(oneTimeMembership?.price?.toLocaleString(), currencySymbol)}`})}</AppText>
                                                                        <FontAwesomeIcon icon={solid('circle-small')} fontSize={'3px'}/>
                                                                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('pfs-recurring-appointment-times', {times: values.repeatConfig.times})}</AppText>
                                                                        <FontAwesomeIcon icon={solid('circle-small')} fontSize={'3px'}/>
                                                                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('pfs-recurring-appointment-total', {total: `${handlePricingWithCurrency((oneTimeMembership?.price * values.repeatConfig?.times)?.toLocaleString(), currencySymbol)}`})}</AppText>
                                                                    </HStack>
                                                                }
                                                                <AppText fontSize={'12px'} color={Colors.newDesign.darkGrey}>{t(`pfs-recurring-appointment-debt-warning${isMobile ? '-mobile' : ''}`)}</AppText>
                                                            </VStack>
                                                        </HStack>)}
                                    />
                                }
                                {
                                    selectionTree['user'].membership_user.length === 0 && selectionTree['user'].type !== 'lead' && !showOneTimePurchase && !allowMultiOneTimeMembership &&
                                    <CustomButtonV2
                                                    onClick={addUserWithoutMembership}
                                                    iconProps={{iconColor: Colors.borderColor, iconHoverColor: Colors.hoverBlueLight}}
                                                    override={() => (
                                                        <HStack space={'1rem'} p={'1rem'} w={'100%'} borderWidth={1} borderRadius={4} borderColor={Colors.newDesign.mainBlue}>
                                                            <Radio onClick={(e) => {
                                                                e.stopPropagation()
                                                                addUserWithoutMembership()
                                                            }} value={oneTimeMembership?.id} size="sm" selected={true}/>
                                                            <HStack space={'0.5rem'} alignItems={'center'}>
                                                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('blockRegisterWithoutMembershipTitle')}</AppText>
                                                            </HStack>
                                                        </HStack>)}
                                    />
                                }
                                {selectionTree['user'].type === 'lead' &&
                                <NBText style={{direction: 'inherit'}}>
                                    <VStack mt={'5px'} marginRight={isRTL() ? 0 : '5px'} marginLeft={isRTL() ? '5px' : 0}><FontAwesomeIcon fontSize={16} icon={solid('triangle-exclamation')}/></VStack>
                                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('lead-appointment-register-explain')} </AppText>
                                </NBText>
                                }
                            </VStack>
                        </Radio.Group>
                    </VStack>
                </VStack>
            </VStack>
            }
            <VStack space={'1rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.heading2Mobile} boldFont>{t('appointment-extras-section-header')}</AppText>
                <Divider style={{ margin: 0 }}/>
                <VStack space={'1rem'}>
                    {!editType &&
                    <FormInput containerProps={{ mb: '0px' }} label={t('send-invite-checkbox-label')} width={'100%'}>
                        <CustomCheckbox text={t('send-invitation-checkbox')} isChecked={!!values.scheduleUser.sendInvitation} onChange={val => setFieldValue('scheduleUser.sendInvitation', val)}/>
                    </FormInput>}
                    {allowScheduleNote &&
                        <Box style={{display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '1rem'}}>
                            <NoteSection values={values} scheduleType={serviceName} setFieldValue={setFieldValue} isAppointment={true}/>
                        </Box>
                    }
                    <Box style={{display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '1rem'}}>
                    { values.customFields?.map((field, index) => (
                        <VStack space={'0.2rem'} key={`appointment-cf-${index}`}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t(field.custom_field_name)}{field.props?.isRequired ? '*' : ''}</AppText>
                            <AdvanceSelect dontSort target={field} initValue={field.value} type={CUSTOM_FIELD_SELECT} options={field.props?.options} onChange={(val) => updateOrAddCustomField(field, val?.value, index)} isClearable={!field.props?.isRequired} isError={!!(touched?.customFields && errors?.customFields?.length > 0 && errors?.customFields[index])}/>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{touched.customFields && errors.customFields && errors.customFields[index] ? errors.customFields[index].value : null}</AppText>
                        </VStack>
                    ))}
                    </Box>
                    {'live_link' in values &&
                        <FormInput containerProps={{ mb: '0px' }} label={t('online-appointment')} infoTooltip={t('online-appointment-tooltip')} width={'100%'}>
                            <LiveLinkSetting selectionValue={values.live_link === null ? 'in-person' : 'online'}
                                             inputValue={values.live_link}
                                             initValue={values.live_link}
                                             onChangeSelection={onOnlineLinkRadioSelection}
                                             onChangeText={(val) => setValue('live_link', val)}
                            />
                        </FormInput>
                    }
                </VStack>
            </VStack>
        </VStack>
    );
};

export default UserAndMembershipSelection;
